import { SPRS_SET } from '../actionConstants';
import { Action } from '../../generalTypes';
import { Spr } from './sprsTypes';
import defaultState from './sprsDefaultState';

export default (state = defaultState, action: Action<Spr>): Spr => {
  switch (action.type) {
    case SPRS_SET:
      return action.payload;
    default:
      return state;
  }
};
